module.exports = __webpack_public_path__ + "img/icon227.a68b5bb4.png";